import React from 'react';
import { Folder, Lock, Users, ChevronRight } from 'lucide-react';
import { Badge } from './ui/badge';

/**
 * FolderCard - Clickable folder icon displayed inline with media files
 */
const FolderCard = ({ folder, onNavigate }) => {
  const getIcon = () => {
    if (folder.type === 'private' || folder.type === 'vendor_folder') {
      return <Lock className="h-8 w-8 text-blue-600" />;
    }
    if (folder.type === 'shared' || folder.type === 'shared_folder') {
      return <Users className="h-8 w-8 text-green-600" />;
    }
    return <Folder className="h-8 w-8 text-gray-600" />;
  };

  const getBgColor = () => {
    if (folder.type === 'private' || folder.type === 'vendor_folder') return 'bg-blue-50';
    if (folder.type === 'shared' || folder.type === 'shared_folder') return 'bg-green-50';
    return 'bg-gray-50';
  };

  const getBorderColor = () => {
    if (folder.type === 'private' || folder.type === 'vendor_folder') return 'border-blue-200';
    if (folder.type === 'shared' || folder.type === 'shared_folder') return 'border-green-200';
    return 'border-gray-200';
  };

  return (
    <button
      onClick={() => onNavigate(folder)}
      className={`group relative rounded-lg border-2 ${getBorderColor()} ${getBgColor()} hover:shadow-lg transition-all overflow-hidden cursor-pointer`}
    >
      {/* Folder Icon Area */}
      <div className="aspect-square flex items-center justify-center p-6">
        {getIcon()}
      </div>

      {/* Folder Info */}
      <div className="bg-white border-t border-gray-200 p-3">
        <div className="flex items-center justify-between gap-2 mb-1">
          <h3 className="text-sm font-semibold text-gray-900 truncate flex-1">
            {folder.name}
          </h3>
          <ChevronRight className="h-4 w-4 text-gray-400 group-hover:text-gray-600 flex-shrink-0" />
        </div>
        
        <div className="flex items-center justify-between text-xs text-gray-500">
          <span>{folder.count || 0} files</span>
          {folder.read_only && (
            <Badge variant="outline" className="text-xs">
              Read-only
            </Badge>
          )}
        </div>
      </div>

      {/* Hover Effect */}
      <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-5 transition-opacity pointer-events-none" />
    </button>
  );
};

export default FolderCard;
